var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotInterstedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43565"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2342",
    cx: 30.5,
    cy: 30,
    r: 30,
    fill: "#809FCE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8333 45.0003V43.2859H37.5V41.667C37.5 40.3409 36.9732 39.0691 36.0355 38.1315C35.0979 37.1938 33.8261 36.667 32.5 36.667H20.8333C19.5073 36.667 18.2355 37.1938 17.2978 38.1315C16.3601 39.0691 15.8333 40.3409 15.8333 41.667V43.2859H12.5V45.0003H45.8333ZM26.6667 21.667C25.5129 21.667 24.3851 22.0091 23.4258 22.6501C22.4666 23.2911 21.7189 24.2021 21.2774 25.268C20.8359 26.3339 20.7203 27.5068 20.9454 28.6384C21.1705 29.7699 21.7261 30.8093 22.5419 31.6251C23.3577 32.4409 24.3971 32.9965 25.5286 33.2216C26.6602 33.4467 27.8331 33.3311 28.899 32.8896C29.9649 32.4481 30.8759 31.7004 31.5169 30.7412C32.1579 29.7819 32.5 28.6541 32.5 27.5003C32.5 25.9532 31.8854 24.4695 30.7915 23.3755C29.6975 22.2816 28.2138 21.667 26.6667 21.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2297 26.4531C43.2091 26.4531 44.0034 27.2474 44.0034 28.2268C44.0034 29.2062 43.2091 30.0005 42.2297 30.0005C41.2504 30.0005 40.4561 29.2062 40.4561 28.2268C40.4561 27.2474 41.2504 26.4531 42.2297 26.4531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6295 19.3981C37.6807 18.2466 38.1588 17.1635 38.9738 16.3488C39.84 15.4827 41.0044 15 42.2295 15C43.4546 15 44.6191 15.4827 45.4852 16.3488C46.3514 17.2146 46.8341 18.3794 46.8341 19.6045C46.8341 20.4388 46.6073 21.2506 46.1786 21.9661C45.7502 22.6811 45.1329 23.2683 44.3979 23.6619C44.1862 23.7755 44.0046 23.936 43.8809 24.1432C43.7568 24.35 43.7049 24.5894 43.7049 24.8288V25.1965C43.7049 25.329 43.5969 25.437 43.4648 25.437H40.9942C40.8621 25.437 40.7541 25.329 40.7541 25.1965V24.8288C40.7541 24.0521 40.9553 23.2981 41.3546 22.6317C41.7542 21.964 42.3273 21.4336 43.0122 21.0666C43.2769 20.925 43.4984 20.7119 43.6527 20.4542C43.8065 20.1969 43.883 19.9039 43.883 19.6045C43.883 19.1643 43.7101 18.7465 43.3989 18.4352C43.0873 18.1239 42.6698 17.9511 42.2295 17.9511C41.7892 17.9511 41.3714 18.1239 41.0601 18.4352C40.7801 18.7153 40.6101 19.084 40.5806 19.4791L40.5722 19.5909C40.5627 19.7181 40.4562 19.8156 40.3286 19.8135L37.8602 19.771C37.7929 19.7696 37.7354 19.7444 37.6895 19.6953C37.6432 19.6463 37.6215 19.5874 37.6243 19.5201L37.6295 19.3981Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotInterstedIcon);
export default __webpack_public_path__ + "static/media/notInterstedIcon.e82022da04545cb6cdc692ea277a6a6a.svg";
export { ForwardRef as ReactComponent };